import * as React from 'react';

import type { ReviewerDetails } from 'pages/open-course/peerReview/components/types';

import ProfileImageCA from 'bundles/compound-assessments/components/shared/ProfileImageCA';

import _t from 'i18n!nls/ondemand';

import 'css!./__styles__/StackedLearnerPhotos';

type Props = {
  learners: ReviewerDetails[];
};

/**
 * Stacks photos of `learners` slightly overlapping left-to-right with photos towards the left above photos towards
 * the right.
 */
const StackedLearnerPhotos = ({ learners }: Props) => {
  return (
    <div className="rc-StackedLearnerPhotos">
      {learners.map((learner, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <span key={`profile-image-${index}`} style={{ zIndex: learners.length - index }}>
          <ProfileImageCA
            profile={{
              fullName: learner.fullName,
              photoUrl: learner.isDefaultPhoto ? undefined : learner.photoUrl,
              isAnonymous: learner.isAnonymous,
            }}
            alt={_t('Photo of learner #{learnerName}', { learnerName: learner.fullName })}
          />
        </span>
      ))}
    </div>
  );
};

export default StackedLearnerPhotos;
